export default __webpack_public_path__ + "static/media/home-line.b0e3e610.svg";